// Check the status of the congestion
export const isResolvedCongestion = (color?: string | null) =>
  color === 'Geel' || color === 'Transparant';
